// Lucide icon: upload (https://lucide.dev/icons/upload)
import { Upload } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconUpload = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Upload />
    </IconComponentStyled>
  )
}
